import React from 'react';
import PropTypes from 'prop-types';
import {
    inplayHomepageUrl,
    inplayEventsUrl,
} from '~spa/Utils/LocalizedUrls';
import { selectionArrayToObject } from '~shared/utils/selections-utils';
import BetCard from '~shared/components/react/BetCard/index';
import EventDescription from '~shared/components/react/EventDescription/EventDescription';

const InplayWidgetEvent = ({
    event,
    markets,
    marketsHeaders,
    selections,
    source,
}) => {
    const {
        id: eventId,
        market_id: marketId,
        grouped_market_ids: groupedMarketIds = [],
        default_market_headers: defaultMarketHeaders = {},
        sport_columns: sportColumns = 0,
        suspended,
        isUsFormat = false,
        usesThreeMarketView,
    } = event;
    const isBetable = !suspended && [].concat(...Object.values(selections)).some(({suspended = true}) => !suspended);
    const gtmTag = `${source};${(source === 'inplay') ? 'featured-inplay' : 'inplay-widget'};`;

    const getBetButtons = () => {
        if(!usesThreeMarketView) {
            const marketHeadersCount = Object.entries(marketsHeaders[marketId] || defaultMarketHeaders).length;
            const columnsCount = (sportColumns > 0) ? sportColumns : marketHeadersCount;
            const orderedSelections = (selections.length < columnsCount) ? reorderSelections(columnsCount) : selections;

            return orderedSelections.map((selection = null) => {
                if (!selection) {
                    return {
                        betable: false,
                    };
                }

                const {
                    suspended,
                    active,
                    tradable,
                    betable,
                } = selection;
                const selectionIsSuspended = suspended || (!active || !tradable);
                const selectionIsBetable = selectionIsSuspended ? !selectionIsSuspended : betable;

                return {
                    ...selection,
                    betable: selectionIsBetable,
                    suspended: selectionIsSuspended,
                };
            });
        }

        return [];
    };

    const getMarkets = () => {
        if(usesThreeMarketView) {
            // Format market to match the preplay endpoint.
            const gamelineMarkets = {};

            // Selections are grouped by market Id
            Object.keys(selections).forEach(marketId => {
                gamelineMarkets[marketId] = {
                    ...markets[marketId],
                    selections: selectionArrayToObject(selections?.[marketId] || []),
                };
            });

            return gamelineMarkets;
        }

        return markets;
    };

    const reorderSelections = (columnsCount) => {
        const mappedSelections = Array(columnsCount).fill(null);

        selections.forEach(selection => {
            const selectionType = selection.selection_type;

            if (selectionType === '1') {
                mappedSelections[0] = selection;
            } else if (columnsCount === 2) {
                mappedSelections[1] = selection;
            } else if (columnsCount === 3) {
                if (selectionType === 'X') {
                    mappedSelections[1] = selection;
                } else if (selectionType === '2') {
                    mappedSelections[2] = selection;
                }
            }
        });

        return mappedSelections;
    };

    return <BetCard
        key={`betcard-${eventId}`}
        event={event}
        description={<EventDescription
            key={`event-description-${eventId}`}
            event={{
                ...event,
                inplay: true,
                event_url: `/${inplayHomepageUrl()}/${inplayEventsUrl()}/${eventId}`,
            }}
            gtm={`${gtmTag}bet-card`}
        />}
        betable={isBetable}
        markets={getMarkets()}
        marketOrder={groupedMarketIds}
        selections={getBetButtons()}
        usesThreeMarketView={usesThreeMarketView}
        isUsFormat={isUsFormat}
        gtmAttribute={gtmTag}
    />;
};

InplayWidgetEvent.propTypes = {
    event: PropTypes.object,
    markets: PropTypes.object,
    marketsHeaders: PropTypes.object,
    selections: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
    ]),
    source: PropTypes.string,
};

export default InplayWidgetEvent;
